<script lang="ts" module>
  import type { HTMLButtonAttributes } from 'svelte/elements';
  import { tv } from 'tailwind-variants';

  export interface LinkButtonProps extends HTMLButtonAttributes {
    size?: 'small' | 'big';
    active?: boolean;
    highlight?: boolean;
    _focus?: boolean; // only for testing
  }

  const styles = tv({
    base: 'fr rounded-t-sm bg-btn-tert p-1',
    variants: {
      size: {
        small: 'text-xs',
        big: 'text-sm',
      },
      active: {
        true: 'border-b',
      },
      highlight: {
        true: 'text-c-link hocus:bg-btn-tert-H',
        false: 'text-c-base hocus:bg-btn-tert-H',
      },
      _focus: {
        true: '!bg-btn-tert-H',
      },
    },
    defaultVariants: {
      size: 'big',
      highlight: false,
      active: false,
      _focus: false,
    },
  });
  /**
   * But where
   * @param {string} children - The content of the button.
   */
</script>

<script lang="ts">
  let { size, active, highlight, children, _focus, ...rest }: LinkButtonProps = $props();
  let cn = $derived(styles({ size, active, highlight, _focus }));
  /**
   * But where
   * @param {string} children - The content of the button.
   */
</script>

<button {...rest} class={cn}>{@render children?.()}</button>
